export default __webpack_public_path__ + "static/media/Shahaf_image.2b065245.jpeg";